import { BaseUserProfile, IUserExperiencePointsInstanceViewModel } from 'fitbeat.models';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import ReactTable, { Filter } from 'react-table';
import { getMemberExperiencePointsHistory } from '../../accountActions/actions';
import { currentGymSelector } from '../../adminSettings/selector';
import { IAppStore } from '../../rootReducer';
import { Loading } from '../../shared/loading';
import {
  nextButton,
  previousButton,
} from './reactTablePaginationButtons';
import { buildExperiencePointsConfigColumnsFromAccessor } from '../filters/experiencePointsColumnConfigFilter';

const stringifyObjectsForCsv = (rows: IUserExperiencePointsInstanceViewModel[]) =>
  rows.map((row) => Object.fromEntries(
    Object.entries(row).map(([key, value]) => [
      key,
      value != null && typeof value === 'object' ? JSON.stringify(value) : value,
    ]),
  ));

interface IOwnProps {
  uid: string;
}

interface IStateProps {
  memberExperiencePointsHistory: IUserExperiencePointsInstanceViewModel[];
  loading: boolean;
  experiencePointsColumns: ReturnType<typeof buildExperiencePointsConfigColumnsFromAccessor>;
  memberDetail: BaseUserProfile | undefined;
}

interface IDispatchProps {
  getMemberExperiencePointsHistory(uid: string): void;
}

type IProps = IOwnProps & IStateProps & IDispatchProps;

class ExperiencePointsHistoryOverviewTable extends Component<IProps> {
  public componentDidMount() {
    this.props.getMemberExperiencePointsHistory(this.props.uid);
  }

  public render() {
    const { memberDetail, memberExperiencePointsHistory } = this.props;
    return (this.props.loading
      ? (
        <div className='loader-container'>
          <Loading />
        </div>
      )
      : (
        <div>
          <CSVLink
            data={stringifyObjectsForCsv(memberExperiencePointsHistory || [])}
            asyncOnClick
            filename={`${memberDetail?.email ?? 'member'}-experience-points-${
              new Date().toISOString()
            }-table.csv`}
            target='_blank'
          >
            <button className='jr-btn-no-border black-color-text'>
              <img className='btnImg csvExportIconContainer' src='resources/images/csv-export-icon.svg' />
              CSV Export
            </button>
          </CSVLink>
          <ReactTable
            className='workout-history-overview-table'
            minRows={0}
            resizable
            showPageSizeOptions
            filterable
            data={this.props.memberExperiencePointsHistory || []}
            loadingText='Loading...'
            noDataText='No data found'
            columns={this.props.experiencePointsColumns}
            defaultPageSize={10}
            defaultFilterMethod={(filter: Filter, row) => String(row[filter.id]) === filter.value}
            defaultSorted={[{ id: 'createdAt', desc: true }]}
            PreviousComponent={previousButton}
            NextComponent={nextButton}
          />
        </div>
      )
    );
  }
}

const mapStateToProps = (state: IAppStore): IStateProps => {
  const { accountActions, members } = state;
  const { memberExperiencePointsHistory } = accountActions.data;
  const { isFetchingExperiencePointsHistory } = accountActions.view;
  const { memberAccountData } = members.data;
  const memberDetail = memberAccountData && memberAccountData.userInfo.profile;
  const currentGym = currentGymSelector(state);
  const experiencePointsColumns = buildExperiencePointsConfigColumnsFromAccessor(currentGym);
  return {
    loading: isFetchingExperiencePointsHistory,
    memberExperiencePointsHistory,
    experiencePointsColumns,
    memberDetail,
  };
};

export default connect(mapStateToProps, { getMemberExperiencePointsHistory })(ExperiencePointsHistoryOverviewTable);
